export const collegeIntroList = [
  {
    label: '国防科技大学是中央军委直属的综合性研究型高等教育院校，是首批进入国家“211工程”建设计划的院校，是军队唯一进入国家“985工程”建设行列的院校，也是军队唯一入选国家首轮“双一流”建设支持的军队院校。'
  },
  {
    label: '国防科技大学系统工程学院成立于<span style="color: #df1a09">2017年9月</span>，位于湖南长沙，是由<span style="color: #df1a09">钱学森于1979年</span> 亲自指导成立的原系统工程与数学系发展而来，是全国最先创建系统工程专业的学院之一，主建的管理科学与工程一级学科是国家<span style="color: #df1a09">“双一流”</span>建设学科，在全国学科评估中位列A+。'
  },
  {
    label: '学院依托国内一流的人才培养体系和科学研究体系，先后为国家和军队培养了<span style="color: #df1a09">13000余名</span>优秀人才，他们中有科技战线的<span style="color: #df1a09">领军人才</span>、军事领域的<span style="color: #df1a09">高级将领</span>、知名企业的<span style="color: #df1a09">高层领导</span>，其中一、二等功臣<span style="color: #df1a09">10余</span>人，全国全军表彰先进人物<span style="color: #df1a09">20余</span>人，军队高级领导<span style="color: #df1a09">40余</span>人。'
  }
]

export const subjectIntroList = [
  {
    label: '学院管理科学与工程、控制科学与工程一级学科为国家重点学科，现有管理科学与工程、控制科学与工程、军队指挥学等3个一级学科博士、硕士学位授权点、博士后科研流动站，电子信息专业博士、硕士学位授权点以及公共管理硕士（MPA）、工程管理硕士（MEM）专业学位授权点。'
  },
  {
    label: '建有31门次国家、军队和省部级一流课程精品课程，2部全国优秀教材，获得4项国家级教学成果和43项省部级教学成果。'
  }
]

export const tearchTeamList = [
  {
    label: '学院拥有一支科研整体水平高、集体攻关能力强、结构合理的师资队伍。教学队伍中有全国优秀教师3人、全军优秀教师6人，2个国家级教学团队，3个湖南省优秀导师团队，1个团队获国家自然科学基金创新群体研究项目资助，近60人入选杰青、卓青等国家和军队重大人才计划，10多人担任国家和军队重大项目总师。'
  },
  {
    label: '在职教师96%以上具有博士学位，其中，高职占比73%，博士生导师占比22%，硕士生导师占比70%。'
  }
]

export const teamIntroList = [{
    label: '战略博弈团队',
    value: '战略博弈团队主要以国家重大战略问题为牵引，开展军事理论、前沿技术的创新和实践运用，重点研究智能化博弈体系架构与方法手段。团队人员由军事学、信息学、管理学专家教授组成，近年来成果申报重大重点课题20余项，发表高水平论文120余篇、授权专利30余项。',
    fontSizeClass: ''
  },
  {
    label: '战略管理与组织决策团队',
    value: '战略管理与组织决策团队主要围绕战略管理与组织行为领域的核心问题，面向公共部门发展与建设需求，开展数据驱动的管理创新理论与方法研究，围绕组织行为与决策、战略规划与执行、人力资源管理等领域问题开展科学研究和工程实践。团队包含国防科技大学教学名师、优秀骨干教师等专家教授与学科带头人，近年来主持包括国家自科基金、社科基金、全军军事理论重点课题、湖南省自科基金等研究课题20余项，发表高水平论文100余篇。',
    fontSizeClass: ''
  },
  {
    label: '战略规划与评估团队',
    value: '战略规划与评估团队主要围绕战略规划与评估、复杂体系设计与优化、集群智能与仿真领域开展科学研究和实践工作，学科专业横跨战略管理工程、系统工程和仿真工程，主持或参与国家863计划、国家自然科学基金、国家社会科学基金、军口重点项目等50余项，获得国家级教学成果二等奖1项，国防科学技术进步二等奖1项，军队、省部级教学科研成果一等奖7项、二等奖10项，在《IEEE Trans》《Simulation》等国际顶刊顶会上发表高水平论文百余篇。',
    fontSizeClass: ''
  },
  {
    label: '系统优化与决策团队',
    value: '系统优化与决策团队由16名核心教员、30余名硕博研究生、60余名工程师团队构成，是专门从事复杂系统优化决策领域人才培养、科学研究和应用创新的国家队。团队长期围绕复杂系统调度、优化、规划、决策等技术领域开展基础理论、方法和技术研究，承担国家重大科研项目100余项，获省部级以上奖励7项，发表高质量论文200余篇，专著10余部，授权专利及软件80余项，是复杂系统优化决策自主创新发展的引领者。',
    fontSizeClass: ''
  },
  {
    label: '复杂系统与体系工程团队',
    value: '复杂系统与体系工程团队是国内最先开展复杂系统与体系工程管理研究的科研队伍之一，主要聚集管理中的复杂体系建模、分析、评估、优化与管理决策等前沿科学问题，开展模型与数据驱动的体系需求获取与分析、体系结构设计与优化、复杂网络建模与评价、体系试验评估、大数据应急管理与智能决策。主持国家重要科研项目90余项，发表高水平学术论文180余篇，授权发明专利和软件著作权20余项，出版专著20余部，获省部级以上科技奖10项。',
    fontSizeClass: ''
  },
  {
    label: '智慧能源创新团队',
    value: '智慧能源创新团队是国内率先开展大数据与人工智能技术在智慧能源领域应用的科研队伍，建有多能源系统智慧互联技术湖南省重点实验室，是湘江实验室首批入驻科研团队。主要从事数据驱动的优化决策、先进智能优化算法、复杂时间序列分析等理论方法及其在大规模电池储能系统、能源互联网、微电网、智慧能源管理、故障预测与健康管理等方面的应用研究，成立以来累计发表高水平学术论文160余篇，授权发明专利40余项，获省部级以上科技奖12项。',
    fontSizeClass: ''
  },
  {
    label: '装备系统工程与管理团队',
    // value: '装备系统工程与管理团队主要从事装备试验鉴定与评估、可靠性工程与质量管理、寿命预测与健康管理、体系试验与效能评估等方面的科学研究，结合若干重大任务开展工程应用研究。主持国家军队重要科研项目60余项，发表论文100余篇，出版学术专著20部，授权发明专利和软件著作权30余项，获省部级以上科技奖15项。',
    value: '装备系统工程与管理团队主要围绕装备全寿命周期管理的科学化、精细化和敏捷化，综合利用数理统计、运筹优化、机器学习等开展装备试验设计与评估、可靠性工程与质量管理、寿命预测与健康管理、装备运用与保障优化、体系试验与效能评估等方面的科学研究，结合高价值装备试验、数字化试验鉴定、联合投送等重大任务开展应用研究。主持国家军队项目60余项，发表论文150余篇，出版专著教材20多部，授权发明专利和软件著作权40余项，获省部级以上科技奖15项。',
    fontSizeClass: ''
  },
  {
    label: '一体化联合仿真团队',
    value: '一体化联合仿真团队由29名核心教员、20余名硕博研究生、110余名工程师团队构成，是专门从事建模仿真共性技术和模拟训练领域人才培养、科学研究和应用创新的国家队。团队长期围绕分布/并行仿真、行为与认知建模、平行仿真、高性能仿真等建模仿真共性技术领域开展基础理论、方法和技术研究，发表高质量论文500余篇，专著20余部，获省部级以上奖励20余项，授权专利40余项。',
    fontSizeClass: ''
  },
  {
    label: '虚拟现实与视觉计算团队',
    value: '虚拟现实与视觉计算团队由10余名教员组成的教学科研团队，主要围绕光电成像系统研制与视觉智能算法研究，率先攻克了全景图像中多光源颜色恒常性算法等关键技术，研制的全景摄像机在天安门广场、APEC北京主会场等地获成功应用，获多项省部级以上奖励、发表多篇高水平论文。',
    fontSizeClass: ''
  },
  {
    label: '复杂系统建模与高性能仿真团队',
    value: '复杂系统建模与高性能仿真团队主要围绕复杂系统可信建模和高效运行的应用需求，开展数智驱动的系统模型构建、基于先进计算架构的高效并行仿真、AI赋能的复杂系统实验等前沿理论方法和关键技术研究，服务支撑装备实验评估、作战实验等重大需求，为现代战争提供强有力的科技支持。主持国家自然科学基金、863计划、军口重点项目30余项，获国家科技进步一等奖2项、二等奖2项，省部级科技成果一等奖4项、二等奖8项、三等奖3项，发表高质量学术论文200余篇。',
    fontSizeClass: 'font-size-18'
  },
  {
    label: '指挥信息系统体系设计技术研究团队',
    value: '指挥信息系统体系设计技术研究团队是信息系统工程全国重点实验室主要团队方向，长期从事系统顶层架构设计、体系优化、体系评估、信息服务、信息推荐、计算机网络等领域科研工作，团队现有核心成员15名，其中高职14人，1名入选“万人领军”，现有在读研究生50余人，承担国家优青等项目多项，团队成员多次获国家/军队科技进步、技术发明、自然科学等奖励。',
    fontSizeClass: 'font-size-16'
  },
  {
    label: '态势认知技术团队',
    value: '态势认知技术团队是信息系统工程全国重点实验室主要团队方向，拥有核心教员24名，多人获得青年托举人才、湖南省杰出基金，累计培养博士研究生60余人，硕士研究生170余人。团队致力于大模型、自然语言处理、知识图谱等理论与技术研究。团队主持国家、省部级科研课题50余项，发表高水平论文200余篇，出版学术专著11部，授权专利60余项，获得省部级以上教学成果奖9项，获得国家科技二等奖1项、省部级以上科技成果奖20余项。',
    fontSizeClass: ''
  },
  {
    label: '运筹优化与智能决策团队',
    value: '运筹优化与智能决策团队是信息系统工程全国重点实验室主要团队方向，致力于组合优化、多目标优化、动态优化、智能优化以及马尔科夫决策、不确定性决策、智能决策等理论与技术研究。团队现有核心成员14名，累计培养硕博研究生70余名，主持国家、省部级科研课题70余项，获得省部级以上奖励20余项，发表高水平论文150余篇，出版学术专著12部，授权专利30余项。',
    fontSizeClass: ''
  },
  {
    label: '数据分析与应用服务技术团队',
    // value: '数据分析与应用服务技术团队主要从事跨媒体信息智能处理、虚拟现实与人机交互、复杂系统理论与方法等方面的研究，研究室现有12名核心成员、40余名硕博研究生，承担国家重大项目20余项，发表高水平论文50余篇，出版专著10余部，获多项省部级以上成果奖励。',
    value: '数据分析与应用服务技术团队主要从事跨媒体信息智能处理、智能安全与对抗识别、虚拟现实与人机交互、复杂系统理论与方法等方面的研究，研究室现有12名核心成员、60余名硕博研究生，承担国家重大项目20余项，发布高水平论文200余篇，出版专著10余部，2人获评全球前2%顶尖科学家，获多项省部级以上成果奖励。',
    fontSizeClass: 'font-size-18'
  },
  {
    label: '大数据与决策（国家级）实验室',
    value: '大数据与决策（国家级）实验室是由国家机关布局建设的新型科研机构，于2021年12月获批成立，实验室聚焦解决大数据体系构建、多域多级融合治理、高效精准分析服务、临机可信智能决策等战略性、前瞻性、基础性重大科学问题。实验室长期承担国家重大科研攻关任务，是多项国家重大工程项目总师单位，在推动国家重要领域向数字化、智能化转型发挥着重要作用。',
    fontSizeClass: 'font-size-18'
  },
  {
    label: '数据信息与人工智能团队',
    value: '数据信息与人工智能团队是一支创新能力强、实践经验丰富的科技骨干队伍，主要从事公共数据体系论证构建研究工作、或大语言模型的能力分析与应用开发、或隐私计算下的人工智能应用开发研究、或数据中心运维管理体系研究，获得省部级以上奖励40余项,授权专利20余项。',
    fontSizeClass: ''
  },
  {
    label: '智能规划与目标工程团队',
    value: '智能规划与目标工程团队，长期从事智能规划与目标体系研究，教育部创新团队核心组成，军委装备发展部和科技委智能相关方向牵头单位，牵头负责全国兵棋推演大赛。承担装备重大基础、国家重点研发计划等国家和军队重大课题50余项。团队现有核心教员20余名，硕博研究生80余名，工程师40余名，获国家科技进步二等奖1项，军队科技进步一等奖2项，省部级/国家一级学会科技进步一等奖4项，在Nature子刊、IEEE汇刊发表高水平论文200余篇。',
    fontSizeClass: ''
  }
]

export const schoolConditionList = [
  {
    label: '学院拥有国内一流的研究实验条件和人才培养环境，建有联合指挥控制系统技术科技创新平台、装备体系工程管理哲学社会科学创新基地2个国家“985工程”科技创新平台，信息系统工程与大数据与决策2个国家级重点实验室，以及湖南先进技术研究院数智仿真协同创新中心、湖南省智能交互技术工程中心、湖南省智能信息系统技术创新应用工程技术研究中心等3个军民融合工程中心。'
  },
  {
    label: '教学科研用房2万平方米，形成了较为完备的教学科研设备体系，能够支撑指挥控制、大数据应用、建模仿真等方向的基础研究和关键技术攻关，教学科研条件居国内同类高校前列。'
  }
]

export const scienceGradeList = [
  {
    label: '学院紧贴国家和军队重大发展需求，在指挥控制、大数据应用、军用仿真等方面做出了重要贡献，着眼解决国防和军队建设系统性、总体性、前瞻性问题，着力突破复杂军事系统和体系管理控制综合化、最优化、智能化核心关键技术,形成了以系统工程方法论为统揽，理工军管交叉融合的科研特色。'
  },
  {
    label: '先后承担国家重大科技专项、国家自然科学基金等国家级科研项目<span style="color: #ffe557;">200多项</span>科研项目，军队、省部级科研项目<span style="color: #ffe557;">1500余项</span>，年均承担<span style="color: #ffe557;">100多项</span>国家和军队重大研究任务。获国家科技进步特等奖<span style="color: #ffe557;">1项</span>、二等奖<span style="color: #ffe557;">9项，2项</span>国家技术发明奖，<span style="color: #ffe557;">300多项</span>军队/省部级科技奖，<span style="color: #ffe557;">40多篇</span>论文入选ESI世界前1%。'
  }
]

export const introduceNeedList = [{
    label: '学科专业',
    value: '研究方向'
  },
  {
    label: '管理科学与工程',
    value: '战略管理理论方法、战略规划评估、项目管理、组织管理、公共人力管理、行政管理、知识网络与知识工程、复杂系统建模优化、优化决策与评估、能源互联网、系统工程与管理'
  },
  {
    label: '控制科学与工程',
    value: '认知智能、智能对抗、复杂系统仿真与优化、系统仿真与辅助决策、群体智能、计算智能与优化技术、无人系统规划技术、自动化技术'
  },
  {
    label: '计算机科学与技术',
    value: '物联网工程、人工智能、软件工程、计算机科学、大数据技术、数据挖掘、知识工程、机器学习、演化计算与智能优化、多智能体系统、分布式计算'
  },
  {
    label: '数学',
    value: '数理统计分析、应用数学、数值分析技术、数据智能分析与应用、数学与信息安全'
  },
  {
    label: '系统科学',
    value: '系统理论与系统分析、运筹学、复杂系统与网络、决策理论与方法'
  },
  {
    label: '军队指挥学',
    value: '军队指挥基础理论、军队指挥系统、军队作战指挥、军队指挥效能评估、军队指挥与信息技术、军队指挥与决策科学'
  },
  {
    label: '公共管理学',
    value: '公共政策、行政管理、政策分析与运筹优化、公共决策理论与方法'
  },
  {
    label: '应用经济学',
    value: '数量经济学、战略博弈推演、经济数据分析、宏观经济系统分析、经济模型与计量方法、经济优化与决策'
  },
  {
    label: '信息与通信工程',
    value: '多模态信息融合、智能决策技术、智能信息处理'
  }
  // {
  //   label: '数学与应用数学、计算机科学与技术、管理科学与工程',
  //   value: '复杂系统仿真与优化、大数据分析、机器学习、演化计算与智能优化、多智能体系统、社会计算'
  // },
  // {
  //   label: '管理科学与工程、计算机科学与技术、数学与应用数学、兵器科学与技术',
  //   value: '战略管理理论方法、战略规划评估、项目管理、组织管理、决策智能优化、武器系统总体设计'
  // },
  // {
  //   label: '管理科学与工程、控制科学与工程、软件工程',
  //   value: '战略规划、知识网络与知识工程、建模仿真、决策分析、智能博弈、情报分析'
  // },
  // {
  //   label: '战略学、公共管理、应用经济学',
  //   value: '国际政治关系、危机管理、公共人力管理、行政管理、战略管理、预算绩效分析、地缘政治'
  // },
  // {
  //   label: '控制科学与工程、管理科学与工程、计算机科学与技术',
  //   value: '人工智能、云仿真、大数据、智能化建模、复杂系统建模与仿真、分布式计算分析、地缘政治'
  // },
  // {
  //   label: '控制科学与工程、计算机科学与技术、软件工程、管理科学与工程',
  //   value: '建模与仿真、数智系统工程、云计算、大数据、计算机网络与通信、高性能仿真、并行与分布软件技术、智能软件技术、网络技术与网络安全、复杂系统建模与仿真'
  // },
  // {
  //   label: '数学、计算机科学与技术、信息与通信工程、管理科学与工程',
  //   value: '计算机体系结构、信息处理与辅助决策、计算机科学与技术、态势感知、体系设计、运筹规划、数据分析、复杂网络、指挥控制、人工智能'
  // },
  // {
  //   label: '管理科学与工程、计算机科学与技术、控制科学与工程、信息与通信工程、软件工程、数学',
  //   value: '数据集成、数据分析与挖掘、人工智能、信号处理、信息处理与辅助决策、态势感知、建模与仿真、统计分析、计算机科学、机器学习、知识工程'
  // },
  // {
  //   label: '其他学科',
  //   value: '上述研究方向交叉相关'
  // },
]

export const introduceTypeList = [{
    label: '科技领军人才',
    value: "政治合格，学术诚信，遵纪守法，身体健康，能够引领本领域创新发展，学术造诣深厚，业绩成果达到国际先进水平，年龄一般不超过五十五周岁，同时具备下列条件之一：\n①国家级人才工程领军层次人选；\n②全国创新争先奖或者相当奖励的获得者；\n③国家自然科学基金创新研究群体或者相当水平团队的带头人；\n④国家科学技术进步奖二等奖以上或者相当奖励项目的技术负责人；\n⑤发表本领域前沿方向、具有国际影响力学术论文的第一作者或者通讯作者；\n⑥国家实验室，国际大科学计划（工程）、国家科技重大专项等国家级工程项目的首席专家或者技术负责人；\n⑦国防科技领域重大工程型号的总设计师或者副总设计师；\n⑧担任国际学术组织理事以上职务或者全国一级学会负责人；\n⑨经国内外同行权威认定，具有以上相当学术技术水平的专家。",
    icon: 'kjljrc',
    iconWidth: 23,
    iconHeight: 25
  },
  {
    label: '学科拔尖人才',
    value: "政治合格，学术诚信，遵纪守法，身体健康，能够引领学科发展，学术技术水平高，业绩成果达到国内领先水平，年龄一般不超过五十周岁，同时具备下列条件之一：\n①国家级人才工程拔尖层次人选；\n②省（部）级人才工程领军人才人选；\n③中国青年科技奖或相当奖励的获得者；\n④国家杰出青年科学基金、国防科技卓越青年科学基金等基金项目的获得者；\n⑤省（部）级科学技术奖一等奖以上或者相当奖励项目的技术负责人；\n⑥在本领域国际顶级学术期刊发表具有重要影响力学术论文的第一作者或者通讯作者；\n⑦国家实验室，国际大科学计划（工程）、国家科技重大专项等国家级工程项目的核心骨干；\n⑧国防科技领域重大工程型号各大系统的总设计师或者副总设计师；\n⑨担任国际学术组织委员以上职务或者全国一级学会副理事长以上职务；\n⑩经国内外同行权威认定，具有以上相当学术技术水平的专家。",
    icon: 'xkbjrc',
    iconWidth: 21,
    iconHeight: 25
  },
  {
    label: '青年科技英才',
    value: "政治合格，学术诚信，遵纪守法，身体健康，在本专业领域崭露头角，具有创新潜力，年龄一般不超过四十周岁，同时具备下列条件之一：\n①国家级人才工程青年层次人选；\n②国家优秀青年科学基金或者相当层次基金的获得者；\n③省（部）级科学技术奖一等奖以上或者相当奖励项目的主要完成人；\n④国家科技重大专项等国家级工程项目，或者国家和省部级重点实验室、工程技术（研究）中心等创新团队的主要成员；\n⑤省（部）级人才工程拔尖层次人选；\n⑥入选国家博士后创新人才支持计划、博士后国（境）外交流项目等国内优秀博士后人才；\n⑦在本领域国际知名学术期刊发表具有较大影响力学术论文的第一作者或者通讯作者；\n⑧掌握独特技能和专长，对加强新型作战力量建设具有重要作用的人才；\n⑨经国内外同行权威认定，具有以上相当学术技术水平的青年骨干。",
    icon: 'qnkjyc',
    iconWidth: 23,
    iconHeight: 24
  },
  {
    label: '学术新秀人才',
    // value: "政治合格，学术诚信，遵纪守法，身体健康，在本专业领域具有丰富学习经历、扎实理论基础和较强创新能力，国家“双一流”建设高校及建设学科、国家最近一轮学科评估A类学科或综合排名世界前200名的海外高校博士，年龄一般不超过35周岁。直接引进的学术新秀人才具备省杰出青年科学基金及以上相当能力。",
    value: "合同专职引进、直接引进文职人员，在符合军队有关政策基础上，原则上为已出站博士后（含批准录用前能按期出站的在站博士后）或具有2年以上高校、科研院所、高精尖企业工作经历的成熟优秀人才。\n政治合格，学术诚信，遵纪守法，身体健康，在本专业领域具有丰富学习经历、扎实理论基础和较强创新能力，35岁以下国家“双一流”建设高校及建设学科、国家最近一轮学科评估A类学科或综合排名世界前200名的海外高校应届博士毕业生，同时还应具备下列条件之一：\n①省（部）级人才工程青年层次以上人选；\n②省（部）级杰出、优秀青年科学基金或者相当层次基金的获得者；\n③省（部）级科学技术奖二等奖以上或者相当奖励项目的主要完成人；\n④省（部）级科技重大专项、重点研发计划等省（部）工程项目，或者省（部）级重点实验室、工程技术（研究）中心等科技创新团队的主要成员（课题负责人或者项目排名前5）；\n⑤获得国家博士后基金资助（不含面上资助和学术交流项目）、学校“德雅青年学者博士后”支持计划人选；\n⑥省级以上一流课程、教学成果二等奖以上的主要完成人（排名前3），教学比赛二等奖以上及相当奖励获得者。",
    icon: 'xsxxrc',
    iconWidth: 21,
    iconHeight: 20 
  },
  {
    label: '青年博士人才',
    // value: "政治合格，品学兼优，身体健康，具有博士学位或已通过博士学位答辩（进站半年内必须取得博士学位），获得博士学位一般不超过3年，年龄应当在35周岁以下。具有较强的科研能力和创新潜力，研究方向与招收方向或课题相关，进站人员必须脱产进站工作。",
    value: "①政治合格，品学兼优，遵纪守法，具有良好的职业道德，身体和心理健康；\n②年龄应当在35周岁以下，具有博士学位或已通过博士学位答辩（进站半年内必须取得博士学位），且获得博士学位不超过3年。对申请进入军队指挥学博士后科研流动站、合作单位的博士后科研工作站，或者在国（境）外取得博士学位的，进站年龄可以放宽至40岁，放宽获得博士学位时间限制；\n③地方有人事（劳动）关系人员及定向委培人员需经行政关系所在单位和拟合作导师所在单位同意；\n④在职博士后原则上需全时脱产到流动站从事博士后研究工作。",
    icon: 'qnbsrc',
    iconWidth: 23,
    iconHeight: 25
  },
  {
    label: '优秀硕士人才',
    value: "主要是指国家“双一流”建设高校毕业的或具有“双一流”建设高校学习、工作经历的硕士研究生。重点补充行政管理岗位和教辅岗位。",
    icon: 'yxssrc',
    iconWidth: 25,
    iconHeight: 25
  },
]

export const introduceModeList = [{
    label: '科技领军人才',
    value: '特招入伍\n\n直接引进军队文职人员\n\n合同专职引进\n\n合同兼职引进',
    icon: 'kjljrc'
  },
  {
    label: '学科拔尖人才',
    value: '特招入伍\n\n直接引进军队文职人员\n\n合同专职引进\n\n合同兼职引进',
    icon: 'xkbjrc'
  },
  {
    label: '青年科技英才',
    value: '特招入伍\n\n直接引进军队文职人员\n\n合同专职引进',
    icon: 'qnkjyc'
  },
  {
    label: '学术新秀人才',
    value: '直接选拔招录军官\n\n公开招考军队文职人员\n\n特招入伍\n\n直接引进军队文职人员\n\n合同专职引进',
    icon: 'xsxxrc'
  },
  {
    label: '青年博士人才',
    value: '直接选拔招录军官\n\n公开招考军队文职人员\n\n博士后\n\n合同聘用',
    icon: 'qnbsrc'
  },
  {
    label: '优秀硕士人才',
    value: '直接选拔招录军官\n\n公开招考军队文职人员\n\n合同聘用',
    icon: 'yxssrc'
  }
]

export const treatmentStandardList = [
  {
    label: '直接选拔\n招录军官',
    // value: '按规定享受相应级别军官工资津贴、福利待遇。【支持学术新秀人才优先申请学校科研计划，安家补助费标准为15-20万元】',
    value: '按规定享受相应衔级现役军人工资津贴，实行动态增长机制，额外享受医疗保障、住房保障、子女教育、探亲休假等福利。【直接选拔招录对象符合“学术新秀人才”条件，可享受高额安家补助费，并支持优先申请学校科研计划】',
    icon: 'zjxbzljg'
  },
  {
    label: '公开招考\n文职人员',
    value: '①薪酬：按规定享受相应级别军队编制内文职人员工资津贴、福利待遇，并按照规定比例缴纳六险二金。\n②安家补助费：通过学校统一认定后发放，具体金额协商确定。\n③其他：科研岗位津贴、科研绩效津贴、课时费、其他福利待遇以及子女教育等福利同直接引进的军队文职人员。',
    icon: 'gkzkwzry'
  },
  {
    label: '特招入伍',
    value: '参照军队相同或者相近条件军官，合理确定军衔等级、待遇级别和专业技术职务；入职后按照现役军官享受各项待遇。',
    icon: 'tzrw'
  },
  {
    label: '直接引进\n文职人员',
    // value: '①学术新秀人才：安家补助费最高40万元，科研启动费最高100万元\n②青年科技英才：安家补助费最高60万元，科研启动费最高200万元\n③学科拔尖人才：安家补助费最高80万元，科研启动费最高300万元\n④科技领军人才：安家补助费最高100万元，科研启动费最高500万元\n综合考虑学历、业绩等因素，与本单位相同条件、同等资历文职人员保持协调平衡；入职后按照军队规定享受文职人员各项待遇。',
    value: '引进层次包括科技领军人才、学科拔尖人才、青年科技英才和学术新秀人才。综合考虑引进对象学历、业绩等因素，与本单位相同条件、同等资历文职人员保持协调平衡；\n直接引进文职人员在军队正式编制岗位工作，依法享有国家工作人员相应权利，入职后按照军队规定享受文职人员各项待遇，其中，安家补助费及科研启动费依照相应层次有关规定发放。',
    icon: 'zjyjwzry'
  },
  {
    label: '合同专职\n引进',
    // value: '①学术新秀人才：年薪税前最高40万\n②青年科技英才：年薪税前最高60万，科研启动费最高200万元\n③学科拔尖人才：年薪税前最高80万，科研启动费最高300万元\n④科技领军人才：年薪税前最高100万，科研启动费最高500万元\n租房补助、住房、医疗、子女教育均可享受。',
    value: '引进层次包括科技领军人才、学科拔尖人才、青年科技英才和学术新秀人才。享受年薪制，具体金额协商确定。入职后按照军队和学校有关规定享受租房补助、住房、医疗、子女教育等福利，其中，安家补助费及科研启动费依照相应层次有关规定发放。\n除享受上述军队统一的待遇保障外，还同步享受湖南省和长沙市人才优待政策，具体根据引进层次和省（市）有关规定执行。',
    icon: 'htzzyj'
  },
  // {
  //   label: '合同兼职\n引进',
  //   value: '①科技领军人才：月薪税前最高8万\n②学科拔尖人才：月薪税前最高6万',
  //   icon: 'htjzyj'
  // },
  {
    label: '博士后',
    value: '①进站博士后享受年薪制，同时给予进站安家费，具体金额根据专业基础、学术水平等情况设定不同档次，由学院考核后综合研究确定。在站期间子女入军队幼儿园、子女学校与学校现役军官同等对待。应届博士毕业生在站6个月内可参评“德雅青年学者博士后”，享受相应年薪与安家费。\n②博士后在站期间科研条件，主要由合作导师（组）提供，相关学术活动所需经费，由上级下拨研究经费和合作导师（组）所主持的科研项目经费中予以支持。\n③博士后可凭进站批复，按规定条件安排校内公寓住房，房租标准按学校有关规定执行，公寓住房无条件分配保障的，按照学校相同资历现役军官标准发放租房补助。\n④博士后进站后按照规定办理校园出入一卡通，享受与学院教职员工相当的用餐标准。\n⑤同等条件下，在站博士后享有优先引进为学院文职人员、合同专职人员的权利。',
    icon: 'bsh'
  },
  {
    label: '合同聘用',
    // value: '区分专业技术、行政管理、工勤技能分类设置薪酬标准；核心关键专业技术人员以及高层次行政管理人员和专业技能人员的工资标准由学院党委按照“一人一策”研究审批确定。\n对备战打仗急需人才、创新能力特别突出的高精尖紧缺人才以及技术技艺特别高超的特殊专业领域人才，可以按照“一人一策”的原则，采取特殊待遇保障政策。\n对高水平创新团队，可以采取团队引进方式，实施“带泥土”的移植。\n文职人员高端人才，还可灵活试行年薪制、项目工资、协议工资等市场化薪酬模式。支持各类引进人才申报“海外优青”、驻地省市高层次人才引进计划等优待政策。',
    value: '区分专业技术、行政管理、工勤技能分类设置薪酬标准；核心关键专业技术人员以及高层次行政管理人员和专业技能人员的工资标准由学院党委按照“一人一策”研究审批确定。\n对备战打仗急需人才、创新能力特别突出的高精尖紧缺人才以及技术技艺特别高超的特殊专业领域人才，可以按照“一人一策”的原则，采取特殊待遇保障政策。\n对高水平创新团队，可以采取团队引进方式，实施“带泥土”的移植。\n文职人员高端人才，还可灵活试行年薪制、项目工资、协议工资等市场化薪酬模式。支持各类引进人才申报“海外优青”。',
    icon: 'htpy'
  }
]

export const footerContentList = [{
    label: '联系人',
    value: '吴老师',
    icon: 'footer-icon2'
  },
  {
    label: '固定电话',
    value: '0731-87006047',
    icon: 'footer-icon1',
    action: 'call'
  },
  {
    label: '移动电话',
    value: '17509990799',
    icon: 'footer-icon3',
    action: 'call'
  },
  {
    label: '邮箱',
    value: 'xtgcyc_gfkd23@nudt.edu.cn',
    icon: 'footer-icon4',
    action: 'copy'
  }
]